// Beneficiary Reducer
const mesObsequesChargedDefaultState = {
		idBeneficiaire:"",
		ceremonie: {
			typeCeremonie: "",
			confessionReligieuse: "",
			texteAutre: "",
			addresseCeremonie: "",
			codePostalCeremonie: "",
			villeCeremonie: "",
			paysCeremonie: "",
			enterrement: {
				concession: false,
				cimetiere: false,
				vouteFamiliale: false,
				addresseCimetiere: "",
				codePostalCimetiere: "",
				villeCimetiere: "",
				paysCimetiere: ""
			},
			incineration: {
				modeDispersionCendres: "",
				remiseUrne: "",
				addresseCimetiere: "",
				codePostalCimetiere: "",
				villeCimetiere: "",
				paysCimetiere: "",
				vouteFamiliale: false
			},
			texteCeremonie: "",
			auteurMusiqueCeremonie: "",
			titreMusiqueCeremonie: "",
			music: []
		},
		typeSoinConservation: "",
		autres: {
			ceremonieVisuelTitre: "",
			responsibleAnimal: {
				prenom: "",
				nom: "",
				email: ""
			}
		}
};

export default (state = mesObsequesChargedDefaultState, action) => {
  switch (action.type) {
      case 'SET_MESOBSEQUES':
          return {
    	  		...state,
    	  		idBeneficiaire:action.data.idBeneficiaire,
				ceremonie: {
					typeCeremonie: action.data.typeCeremonie,
					confessionReligieuse: action.data.confessionReligieuse,
					addresseCeremonie: action.data.addresseCeremonie,
					codePostalCeremonie: action.data.codePostalCeremonie,
					villeCeremonie: action.data.villeCeremonie,
					paysCeremonie: action.data.paysCeremonie,
					enterrement: {
						concession: action.data.enterrement.concession,
						cimetiere: action.data.enterrement.cimetiere,
						vouteFamiliale: action.data.enterrement.vouteFamiliale,
						addresseCimetiere: action.data.enterrement.addresseCimetiere,
						codePostalCimetiere: action.data.enterrement.codePostalCimetiere,
						villeCimetiere: action.data.enterrement.villeCimetiere,
						paysCimetiere: action.data.enterrement.paysCimetiere
					},
					incineration: {
						modeDispersionCendres: action.data.incineration.modeDispersionCendres,
						remiseUrne: action.data.incineration.remiseUrne,
						addresseCimetiere: action.data.incineration.addresseCimetiere,
						codePostalCimetiere: action.data.incineration.codePostalCimetiere,
						villeCimetiere: action.data.incineration.villeCimetiere,
						paysCimetiere: action.data.incineration.paysCimetiere,
						vouteFamiliale: action.data.incineration.vouteFamiliale
					},
					texteCeremonie: action.data.texteCeremonie,
					auteurMusiqueCeremonie: action.data.auteurMusiqueCeremonie,
					titreMusiqueCeremonie: action.data.titreMusiqueCeremonie,
					music: action.data.music
				},
				typeSoinConservation: action.data.typeSoinConservation,
				autres: {
					ceremonieVisuelTitre: action.data.ceremonieVisuelTitre,
					responsibleAnimal: {
						prenom: action.data.responsibleAnimal.prenom,
						nom: action.data.responsibleAnimal.nom,
						email: action.data.responsibleAnimal.email
					}
				}
          };
      default:
          return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/mesObseques.js